import './Footer.css';

const Footer = () => {

  return (
    <footer>
      <p>Duksung Women's University</p>
      <p>소프트웨어전공 제 3회 졸업작품전시회: 공명(共鳴)</p>
      <p>2025. 09. 07 - 2025. 09. 09 덕성여자대학교 오스카라운지</p>
      <p>Copyright ⓒ 2025 DSWU SOFTWARE All rights reserved.</p>

    </footer>
  );
};

export default Footer;
